export const BUSINESS = {
  name: "Authority Detailing Co.",
  slogan: "Setting the Standard. Leading the Industry. Earning Your Trust.",
  phone: "(480) 401-9892",
  phoneRaw: "4804019892",
  email: "contact@azauthoritydetailingco.com",
  area: "Phoenix, AZ & Surrounding Areas",
  hours: "Mon – Sat · 7:00 AM – 7:00 PM",
  logo: "https://customer-assets.emergentagent.com/job_premium-auto-care-51/artifacts/3bce7fa5_A8299BBE-C456-4F06-A0FD-935D41EACD56.jpg",
  social: {
    instagram: "https://instagram.com/",
    facebook: "https://facebook.com/",
    tiktok: "https://tiktok.com/",
  },
};

export const PACKAGES = [
  {
    id: "3rd_degree",
    tier: "3rd Degree",
    label: "Maintenance Detail",
    sedan: 150,
    suv: 175,
    time: "1 – 1.5 hours",
    popular: false,
    purpose: "Keep a vehicle that is already in decent condition clean and maintained.",
    exterior: [
      "Hand wash",
      "Wheels & tires cleaned",
      "Tire dressing",
      "Exterior glass cleaned",
      "Professional dry-down",
    ],
    interior: [
      "Thorough vacuum",
      "Dashboard cleaned",
      "Center console cleaned",
      "Door panels cleaned",
      "Cupholders cleaned",
      "Interior glass cleaned",
      "Light surface cleaning",
    ],
    notIncluded: [
      "Shampoo/extraction",
      "Heavy stain removal",
      "Heavy pet hair",
      "Steam cleaning",
      "Clay/decontamination",
      "Paint correction",
      "Severe interior restoration",
    ],
    bestFor: "Returning customers and regularly maintained vehicles.",
    features: [
      "Hand wash + dry",
      "Wheels & tires cleaned",
      "Tire dressing",
      "Exterior glass",
      "Thorough interior vacuum",
      "Dashboard, console, door panels",
      "Cupholders + interior glass",
      "Light surface cleaning",
    ],
  },
  {
    id: "2nd_degree",
    tier: "2nd Degree",
    label: "Full Interior + Exterior Detail",
    sedan: 299,
    suv: 349,
    time: "2.5 – 3.5 hours",
    popular: true,
    purpose: "A complete inside-and-out transformation for the average customer's vehicle.",
    exterior: [
      "Thorough hand wash",
      "Wheels & tires cleaned",
      "Wheel wells cleaned",
      "Bug & road-grime removal",
      "Door jambs cleaned",
      "Chemical paint decontamination when necessary",
      "Light clay treatment when necessary",
      "Exterior glass cleaned",
      "Tire dressing",
      "Spray sealant/protection",
    ],
    interior: [
      "Deep vacuum",
      "Dashboard & console detailed",
      "Door panels detailed",
      "Cupholders cleaned",
      "Vents & accessible crevices cleaned",
      "Seats cleaned",
      "Carpets & floor mats cleaned",
      "Light spot treatment",
      "Interior glass cleaned",
      "Leather/vinyl/plastic surfaces appropriately cleaned and conditioned",
      "Targeted steam cleaning where appropriate",
    ],
    disclosure:
      "Severe staining, excessive pet hair, heavily neglected interiors, or unusually contaminated vehicles may require additional services or charges. Any additional charge will be discussed with and approved by the customer before additional work is performed.",
    bestFor: "Customers who want their vehicle thoroughly cleaned inside and out.",
    features: [
      "Everything in 3rd Degree",
      "Wheel wells + door jambs",
      "Bug & road-grime removal",
      "Chemical decontamination (as needed)",
      "Light clay treatment (as needed)",
      "Spray sealant / paint protection",
      "Seats, carpets, floor mats cleaned",
      "Leather / vinyl / plastic conditioned",
      "Targeted steam cleaning",
    ],
  },
  {
    id: "1st_degree",
    tier: "1st Degree",
    label: "Paint Enhancement + Protection",
    sedan: 549,
    suv: 649,
    time: "5 – 7 hours",
    popular: false,
    flagship: true,
    purpose: "Improve the vehicle's paint appearance, restore gloss, reduce light defects, and add protection.",
    paintPrep: [
      "Pre-wash",
      "Thorough hand wash",
      "Wheels & tires cleaned",
      "Iron/fallout removal",
      "Clay decontamination",
      "Paint inspection",
      "Masking where necessary",
    ],
    paintEnhancement: [
      "One-step machine polish",
      "Light swirl reduction",
      "Light oxidation reduction",
      "Gloss enhancement",
      "Panel preparation",
      "Paint sealant/protection",
      "Final inspection",
    ],
    interiorNote: "Includes the 2nd Degree interior service.",
    disclosure:
      "One-step enhancement is intended for light-to-moderate defects. Deep scratches and defects requiring multi-stage correction are not automatically included. We do not promise complete removal of every defect.",
    bestFor: "Customers who care about their paint and want improved gloss + protection.",
    features: [
      "Everything in 2nd Degree",
      "Iron / fallout removal",
      "Full clay decontamination",
      "One-step machine polish",
      "Light swirl + oxidation reduction",
      "Gloss enhancement",
      "Paint sealant / protection",
      "Final inspection walk-through",
    ],
  },
];

export const ADDONS = [
  {
    id: "engine_bay",
    name: "Engine Bay Detail",
    price: 50,
    priceLabel: "+$50",
    desc: "Professional cleaning of accessible engine-bay surfaces.",
  },
  {
    id: "headlight_restoration",
    name: "Headlight Restoration",
    price: 60,
    priceLabel: "+$60",
    desc: "Multi-stage restoration, polishing, and UV protection.",
  },
  {
    id: "pet_hair",
    name: "Pet Hair Removal",
    price: 50,
    priceLabel: "Starting at +$50",
    variable: true,
    desc: "Pricing varies according to severity and amount of hair.",
  },
  {
    id: "odor_treatment",
    name: "Odor Treatment",
    price: 75,
    priceLabel: "+$75",
    desc: "Odor treatment designed to reduce unwanted odors. Severe odors caused by contamination may require additional cleaning/source removal.",
  },
];

// Authority+ Vehicle Maintenance
export const AUTHORITY_PLUS_VEHICLE = {
  sedan: 130,
  suv: 150,
  regularSedan: 150,
  regularSuv: 175,
  benefits: [
    "Exclusive recurring maintenance rate",
    "Keeps your vehicle consistently clean",
    "Preserves detailing results between deeper services",
  ],
};

// Trash bin cleaning — three frequency options
export const BIN_FREQUENCIES = [
  {
    id: "one_time",
    label: "One-Time Service",
    price: 35,
    priceLabel: "$35 per bin",
    desc: "A single cleaning, no commitment.",
  },
  {
    id: "monthly",
    label: "Monthly Service",
    price: 20,
    priceLabel: "$20 per bin",
    desc: "Once a month. Bins stay fresh year-round.",
    badge: "Save",
  },
  {
    id: "bi_weekly",
    label: "Bi-Weekly Service",
    price: 15,
    priceLabel: "$15 per bin",
    desc: "Approximately every 2 weeks. About 26 services per year.",
    badge: "Best Value",
  },
];

export const REASONS = [
  { icon: "Truck", title: "Fully Mobile Service", text: "We bring the studio to your driveway or office." },
  { icon: "Wrench", title: "Professional Equipment", text: "Commercial-grade extractors, polishers & steamers." },
  { icon: "FlaskConical", title: "Premium Chemicals", text: "pH-balanced, pro-grade chemistry only." },
  { icon: "ScanEye", title: "Attention to Detail", text: "Every panel, every stitch — checked twice." },
  { icon: "BadgeCheck", title: "Licensed & Insured", text: "Fully covered for your peace of mind." },
  { icon: "CalendarCheck", title: "Reliable Scheduling", text: "Confirmed appointment windows — clear communication." },
  { icon: "ThumbsUp", title: "Honest Limitations", text: "We explain what we can and cannot do — upfront." },
  { icon: "MapPin", title: "Phoenix Local", text: "Built for desert heat, dust, and sun damage." },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Book Online", desc: "Choose a service, package, and time." },
  { n: "02", title: "We Come To You", desc: "Fully mobile — home, office, or jobsite." },
  { n: "03", title: "Professional Service", desc: "Approved chemistry, professional tools." },
  { n: "04", title: "Final Walk-Through", desc: "We confirm your satisfaction before leaving." },
  { n: "05", title: "Drive Away Fresh", desc: "Protected, polished, and proud." },
];

export const FAQS = [
  { q: "Do you come to me?", a: "Yes. We're a fully mobile service. We come to your home, office, or jobsite." },
  { q: "What areas do you service?", a: "Phoenix, AZ and surrounding areas. Call us if you're outside the metro area." },
  { q: "What's included in each package?", a: "See the Mobile Auto Detailing section for the full inclusion list for each package." },
  { q: "What's the difference between the three degrees?", a: "3rd Degree is a maintenance detail. 2nd Degree is a full interior + exterior detail. 1st Degree is 2nd Degree plus paint enhancement and protection." },
  { q: "What happens with pet hair?", a: "Light pet hair is included. Heavy or embedded pet hair may require the Pet Hair Removal add-on, priced based on severity." },
  { q: "What happens with severe stains?", a: "Severe staining may require additional labor or services beyond the base package. Any additional charge will be discussed with and approved by you before the extra work is performed." },
  { q: "How does pricing work?", a: "Base packages are fixed. Certain add-ons and unusually difficult vehicles may require additional labor — always discussed and approved upfront." },
  { q: "How does booking work?", a: "Choose your service, package, and preferred date/time on the site. You'll receive a booking request confirmation. We contact you to confirm the appointment." },
  { q: "Do I need to provide water or power?", a: "Yes — for the time being, we require access to a water hookup and an electrical outlet at the service location for both auto detailing and trash bin cleaning." },
  { q: "What happens after I book?", a: "You'll receive an email copy of your booking request. We'll review it and contact you to confirm the appointment and any details before your service date." },
];

// Trash Bin Cleaning FAQ (separate list)
export const BIN_FAQS = [
  { q: "What's included?", a: "Hot-water pressure wash of the inside and outside of your bin, sanitizing, deodorizing, and a fresh finish." },
  { q: "How much does it cost?", a: "One-Time is $35 per bin. Monthly is $20 per bin. Bi-Weekly is $15 per bin." },
  { q: "What is Bi-Weekly service?", a: "Bi-Weekly service happens approximately every 2 weeks — about 26 services per year." },
  { q: "Do I need a water hookup?", a: "Yes. For the time being, we require access to a usable water connection at the service location." },
  { q: "Do I need an electrical hookup?", a: "Yes. For the time being, we require access to a usable electrical outlet at the service location." },
  { q: "What happens after I book?", a: "You'll receive an email confirmation. We'll reach out to confirm the appointment before your service." },
];

// Gallery (from earlier upload — real customer photos)
export const GALLERY = [
  { category: "Exterior", label: "Paint Correction & Polish", image: "/gallery/exterior-paint-wheel.jpg", desc: "Dust and oxidation removed. Deep mirror-gloss restored." },
  { category: "Exterior", label: "Wheel & Body Detail", image: "/gallery/exterior-wheel-paint.jpg", desc: "Brake dust dissolved, paint polished to a clean reflection." },
  { category: "Exterior", label: "Engine Bay Detail", image: "/gallery/engine-bay.jpg", desc: "Grimy engine bay restored to a like-new appearance." },
  { category: "Exterior", label: "Headlight Restoration", image: "/gallery/headlight-restoration.jpg", desc: "Oxidation sanded out, lens polished, UV sealant applied." },
  { category: "Interior", label: "Carpet & Cargo Deep Clean", image: "/gallery/interior-cargo.jpg", desc: "Hot-water extraction lifts dirt, sand, and pet hair out." },
  { category: "Interior", label: "Center Console Detail", image: "/gallery/interior-console.jpg", desc: "Crevices, cup holders, and shifter area meticulously cleaned." },
  { category: "Interior", label: "Upholstery Shampoo", image: "/gallery/interior-seats.jpg", desc: "Heavy staining lifted with extraction shampoo." },
];


